function dispatcherDel (stream, requestFn) {
  return function (id) {
    return requestFn(id)
      .map(() => stream.put(id))
  }
}

module.exports = dispatcherDel
